<template>
  <div class="language-switcher" v-bind:class="{ open: opened }">
    <span @click="toggle">{{currentLanguage}}</span>
    <ul>
      <li v-for="language in supportedLanguages" v-bind:class="{ active: currentLanguage == language }" :key="language">
        <a @click="switchTo(language)">{{language}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import {Validator} from 'vee-validate'
import moment from 'moment'
import {setTimeout} from 'timers'

export default {
  created() {
    this.loadCurrentLanguage()
  },
  data() {
    return {
      supportedLanguages: ['fr', 'nl', 'de'],
      currentLanguage: 'fr',
      opened: false
    }
  },
  watch: {
    routeLang: function(newLang, oldLang) {
      if (newLang) {
        this.registerLanguage(newLang)
      } else {
        this.loadCurrentLanguage()
      }
    }
  },
  computed: {
    routeLang() {
      return this.$route.query.lang
    }
  },
  methods: {
    toggle() {
      this.opened = !this.opened
    },
    switchTo(language) {
      this.registerLanguage(language)
      window.history.pushState({}, null, '/#' + this.$route.path)
      this.reloadIfCookieDeclarationPage(this.$route.path)
      this.toggle()
    },
    loadCurrentLanguage() {
      let language = window.localStorage.currentLanguage
      this.registerLanguage(language)
    },
    registerLanguage(language) {
      if (!this.isValid(language)) {
        language = this.supportedLanguages[0]
      }
      // change local state
      this.currentLanguage = language
      // change local storage
      window.localStorage.currentLanguage = language
      // set translations module
      this.$i18n.set(language)
      // set validation module
      Validator.localize(language)
      // set dates module
      moment.locale(language)
      // set lang for CookieBot consent banner
      this.reloadCookiebot(language)
    },
    reloadIfCookieDeclarationPage(path) {
      // need to reload the page because dynamic language change on the script makes no effect.
      if (path === '/cookies-declaration') window.location.reload()
    },
    reloadCookiebot(language) {
      let cookiebotScript = document.getElementById('Cookiebot')
      //let parent = cookiebotScript.parentNode
      //cookiebotScript = parent.removeChild(cookiebotScript)
      cookiebotScript.setAttribute('data-culture', language.toUpperCase())
      //parent.appendChild(cookiebotScript)
    },
    isValid(language) {
      return this.supportedLanguages.indexOf(language) > -1
    }
  }
}
</script>
